module.exports = __webpack_public_path__ + "static/media/fone.6c34933f.svg";